<template>
    <div>
        <Modal
                v-model="modal"
               width="360"
                @on-ok="ok"
                @on-visible-change="visableChange"
               :closable="false"
        >
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>请选择创建环境</span>
            </p>
            <div style="text-align: center;">
                <RadioGroup v-model="mcpTypeId" v-for="item in envList" v-show="envList.length > 0 ">
                    <Radio :label="item.mcp_type" border>{{item.mcp_type_name}}</Radio>
                </RadioGroup>
                <span v-if="envList.length == 0 ">暂无可用服务</span>
            </div>
        </Modal>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    export default {
        name:"selectMcp",
        props:{
            returnMcp:{
                type:Function,
                required:true,
            }
        },
        data(){
            return {
                modal:false,
                mcpTypeId:0,
                mcpCheckInfo:{"mcp_type":0,"mcp_type_name":"","mcp_endpoint":{"id":0,"name":"","domain_name":""}},
                envList:[],
            }
        },
        methods:{
            ...mapActions({
                get_availableSvc:'common/get_availableSvc'
            }),
            isshow(flag) {
                this.modal = flag
            },
            ok(){
                if(this.mcpTypeId > 0){
                    this.envList.forEach(item=>{
                      if(item.mcp_type == this.mcpTypeId){
                          this.mcpCheckInfo = item;
                      }
                    });
                    this.returnMcp(this.mcpTypeId,this.mcpCheckInfo);
                }
            },
            visableChange(show){
                let _this = this;
                if(show){
                    // 获取可用节点
                    this.get_availableSvc({
                        callback:res=>{
                            _this.envList = res;
                            _this.envList.forEach(item=>{
                                if(item.default){
                                    _this.mcpTypeId = item.mcp_type;
                                }
                            })
                        }
                    })
                }
            }
        }
    }
</script>
